/** One appearance preference for the storefront, articles and customizer UI.
 * Artwork/design state never participates. Initial resolution is inline in
 * site-theme-init.liquid; CSS is render-blocking so a toggle is synchronous.
 */
(function () {
  'use strict';
  var KEY = 'skylit-site-theme';
  var root = document.documentElement;
  var controls = '[data-site-theme-toggle], .reading-theme-toggle, #sm2-toolbar-theme, #moonToolbarTheme, #lm-toolbar-theme';
  function current() { return root.getAttribute('data-site-theme') === 'dark' ? 'dark' : 'light'; }
  function paint(button) {
    var dark = current() === 'dark';
    button.setAttribute('aria-pressed', String(dark));
    button.setAttribute('aria-label', dark ? 'Switch to light mode' : 'Switch to dark mode');
    button.title = dark ? 'Light mode' : 'Dark mode';
    var label = button.querySelector('.rtt-label, .sm2-theme-label, .cust-toolbar-btn-label');
    var text = dark ? 'Light' : 'Dark';
    if (label && label.textContent !== text) label.textContent = text;
  }
  function sync() { document.querySelectorAll(controls).forEach(paint); }
  function apply(theme, persist) {
    theme = theme === 'dark' ? 'dark' : 'light';
    root.setAttribute('data-site-theme', theme);
    root.setAttribute('data-reading-theme', theme);
    root.setAttribute('data-customizer-theme', theme);
    var meta = document.querySelector('meta[name="theme-color"]');
    if (meta) meta.content = theme === 'dark' ? '#12101a' : '#ffffff';
    if (persist) {
      try { localStorage.setItem(KEY, theme); } catch (e) { /* In-memory switching remains available. */ }
    }
    sync();
    window.dispatchEvent(new CustomEvent('skylit:themechange', { detail: { theme: theme } }));
  }
  window.SkylitTheme = {
    current: current,
    set: function (theme) { apply(theme, true); },
    bind: function (button) { button.setAttribute('data-site-theme-toggle', ''); paint(button); }
  };
  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest(controls);
    if (button && !button.disabled) apply(current() === 'dark' ? 'light' : 'dark', true);
  });
  window.addEventListener('storage', function (event) {
    try { if (event.storageArea && event.storageArea !== localStorage) return; } catch (e) { return; }
    if (event.key === KEY || event.key === null) apply(event.newValue, false);
  });
  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) { sync(); return; }
    var theme = current();
    try { theme = localStorage.getItem(KEY) === 'dark' ? 'dark' : 'light'; } catch (e) {}
    apply(theme, false);
  });
  document.addEventListener('shopify:section:load', sync);
  function ready() {
    apply(current(), false);
    // Section Rendering and customizer toolbars can insert controls after boot.
    new MutationObserver(function (changes) {
      if (changes.some(function (change) {
        return Array.from(change.addedNodes).some(function (node) {
          return node.nodeType === 1 && (node.matches(controls) || node.querySelector(controls));
        });
      })) sync();
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready);
  else ready();
})();
